import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: "dr-confirm-dialog",
	templateUrl: "./confirm-dialog.component.html",
	styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent {
	constructor(
		public readonly dialogRef: MatDialogRef<ConfirmDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public readonly data: ConfirmDialogData,
	) {}

	onCancelClick(): void {
		this.dialogRef.close(false);
	}
}

export interface ConfirmDialogData {
	ok: string;
	cancel: string;
	title: string;
}
